import { axiosGETDolphinAuth, API_PATH } from "./NetworkUtils";
import { logOperationalMetric } from "../../overview/utils/utils";
import { DolphinVerificationProcessName } from "../../util/Constants";

export const getUsernameForBarcode = async (barcode) => {
  try {
    const response = await axiosGETDolphinAuth(
      `${API_PATH.GET_USERNAME_FOR_BARCODE}/${barcode}`,
      "",
    );
    logOperationalMetric(
      Date.now(),
      DolphinVerificationProcessName,
      "DolphinAuthCall",
      true,
    );
    return response;
  } catch (error) {
    logOperationalMetric(
      Date.now(),
      DolphinVerificationProcessName,
      "DolphinAuthCall",
      false,
    );
    console.error(
      "error during the network call for getUsernameForBarcode: ",
      error,
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/scanBarcode/network/ScanBarcodeNetworkAPI.js